<form (ngSubmit)="onSubmit()" class="space-y-8">
    @if (hasSteps && !flattenSteps) {
        <p-steps [model]="stepItems" [(activeIndex)]="activeStep" [readonly]="false" class="mb-6"></p-steps>
    }
    <div class="transition-all duration-500 ease-in-out animate-fadeStep">
        @if (hasSteps) {
            <div class="mx-auto max-w-7xl p-8 rounded-2xl shadow-xl bg-white text-gray-900 m-2 dark:bg-surface-900 dark:text-white transition-all duration-300">
                <h2 class="text-xl font-semibold text-surface-800 dark:text-white border-b border-green-700 pb-2 mb-4">{{ 'Paso ' + (activeStep + 1) + ':' }}</h2>
                <app-fieldset-wrapper [title]="stepItems[activeStep].label" [cols]="getColumnaSteps()">
                    @for (field of getFieldsByStep(activeStep); track field) {
                        @if (!field.showWhen || field.showWhen(formData)) {
                            <ng-container *ngTemplateOutlet="fieldTemplate; context: { field: field }"></ng-container>
                        }
                    }
                </app-fieldset-wrapper>
            </div>
        } @else {
            <div class="mx-auto max-w-7xl p-8 rounded-2xl shadow-xl bg-white text-gray-900 m-2 dark:bg-surface-900 dark:text-white transition-all duration-300">
                <!-- Envolver campos en una grid responsive para que las clases col-span funcionen en móvil -->
                <div [ngClass]="'grid grid-cols-1 md:grid-cols-' + getColumnaSteps() + ' gap-4'">
                    @for (field of config; track field) {
                        @if (!field.showWhen || field.showWhen(formData)) {
                            <ng-container *ngTemplateOutlet="fieldTemplate; context: { field: field }"></ng-container>
                        }
                    }
                </div>
            </div>
        }
    </div>

    @if (hasSteps && !flattenSteps) {
        <div class="flex justify-between items-center mt-8">
            <button
                type="button"
                pButton
                class="relative group overflow-hidden border-2 rounded-full px-6 py-2 font-medium transition-all duration-300 border-[#D4A520] bg-transparent dark:border-white"
                (click)="prevStep()"
                [disabled]="activeStep === 0"
            >
                <span class="relative z-10 flex items-center gap-2 text-[#D4A520] dark:text-white transition-colors duration-300 group-hover:text-white">
                    <i class="pi pi-chevron-left"></i>
                    Anterior
                </span>
                <span class="absolute inset-0 bg-[#D4A520] scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-right"></span>
            </button>
            @if (activeStep < stepItems.length - 1) {
                <button
                    type="button"
                    pButton
                    class="relative group overflow-hidden border-2 rounded-full px-6 py-2 font-medium transition-all duration-300 border-[#D4A520] bg-transparent dark:border-white"
                    [disabled]="!isStepValid(activeStep)"
                    (click)="nextStep()"
                >
                    <span class="relative z-10 flex items-center gap-2 text-[#D4A520] dark:text-white transition-colors duration-300 group-hover:text-white">
                        Siguiente
                        <i class="pi pi-chevron-right"></i>
                    </span>
                    <span class="absolute inset-0 bg-[#D4A520] scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></span>
                </button>
            }
            @if (activeStep === stepItems.length - 1 && !readOnly) {
                <button type="submit" pButton class="relative group overflow-hidden border-2 rounded-full px-6 py-2 font-medium transition-all duration-300 border-[#D4A520] bg-transparent dark:border-white">
                    <span class="relative z-10 flex items-center gap-2 text-[#D4A520] dark:text-white transition-colors duration-300 group-hover:text-white">
                        Enviar
                        <i class="pi pi-chevron-right"></i>
                    </span>
                    <span class="absolute inset-0 bg-[#D4A520] scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></span>
                </button>
            }
        </div>
    }

    @if (!hasSteps || flattenSteps) {
        <div class="mt-8 text-right">
            @if (!readOnly) {
                <button type="submit" [disabled]="readOnly" class="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded hover:bg-green-700">Enviar</button>
            }
            @if (readOnly) {
                <button type="button" class="px-4 py-2 text-sm font-medium text-gray-600 bg-gray-200 rounded">Modo sólo lectura</button>
            }
        </div>
    }
</form>
<ng-template #fieldTemplate let-field="field">
    @if (field.type === 'textarea') {
        <!-- p-floatLabel para textarea -->
        <div [ngClass]="'col-span-1 md:col-span-' + getColumnaSteps() + ' w-full my-3'">
            @if (field.type === 'textarea') {
                <p-floatLabel class="w-full">
                    <textarea
                        pInputTextarea
                        class="w-full"
                        [(ngModel)]="formData[field.name]"
                        [name]="field.name"
                        placeholder="{{ field.placeholder || '' }}"
                        [readonly]="field.isReadOnly"
                        [id]="field.name"
                        rows="4"
                        (ngModelChange)="onFieldChange(field.name, $event)"
                    ></textarea>
                    <label class="block text-gray-600 text-sm leading-tight break-words whitespace-normal" [for]="field.name"
                        >{{ field.label }}
                        @if (field.required) {
                            <span class="text-red-500">*</span>
                        }
                    </label>
                </p-floatLabel>
            }
        </div>
    } @else {
        <div class="col-span-1 my-3">
            @if (['text', 'number'].includes(field.type)) {
                <p-floatLabel class="w-full">
                    <input
                        pInputText
                        [type]="field.type"
                        [(ngModel)]="formData[field.name]"
                        placeholder="{{ field.placeholder || '' }}"
                        [name]="field.name"
                        [disabled]="field.isReadOnly || false"
                        [attr.min]="field.min !== undefined ? field.min : null"
                        [attr.max]="field.max !== undefined ? field.max : null"
                        [id]="field.name"
                        class="w-full"
                        pSize="large"
                        (ngModelChange)="onFieldChange(field.name, $event)"
                    />
                    <label [for]="field.name" class="block text-gray-600 text-sm leading-tight break-words whitespace-normal">
                        {{ field.label }}
                        @if (field.required) {
                            <span class="text-red-500">*</span>
                        }
                    </label>
                </p-floatLabel>
            }
            <!-- Mensaje informativo -->
            @if (field.type === 'message') {
                @if ((field.messageVariant||'box') === 'box') {
                    <div class="p-4 rounded-md border text-sm my-2"
                         [ngClass]="{
                           'bg-blue-50 border-blue-300 text-blue-700': (field.severity||'info')==='info',
                           'bg-green-50 border-green-300 text-green-700': field.severity==='success',
                           'bg-yellow-50 border-yellow-300 text-yellow-700': field.severity==='warn',
                           'bg-red-50 border-red-300 text-red-700': field.severity==='error'
                         }">
                        <div class="flex items-start gap-2">
                            @if (field.icon) { <i class="pi" [ngClass]="field.icon"></i> }
                            <div class="leading-snug">
                                <strong>{{ field.label }}</strong><br />
                                @if (!field.richText) {
                                    <span>{{ formData[field.name] || field.placeholder }}</span>
                                } @else {
                                    <span [innerHTML]="formData[field.name] || field.placeholder"></span>
                                }
                            </div>
                        </div>
                    </div>
                } @else {
                    <small class="block my-1 text-xs font-medium" [ngClass]="{
                      'text-red-600': (field.severity||'info')==='error' || field.severity==='warn',
                      'text-gray-600': (field.severity||'info')==='info',
                      'text-green-600': field.severity==='success'
                    }">
                        @if (field.icon) { <span class="mr-1"><i class="pi" [ngClass]="field.icon"></i></span> }
                        @if (!field.richText) {
                            <span>{{ formData[field.name] || field.placeholder || field.label }}</span>
                        } @else {
                            <span [innerHTML]="formData[field.name] || field.placeholder || field.label"></span>
                        }
                    </small>
                }
            }
            <!-- p-floatLabel para hora -->
            @if (field.type === 'time') {
                <p-floatLabel class="w-full">
                    <p-datepicker
                        [showIcon]="true"
                        [(ngModel)]="formData[field.name]"
                        placeholder="{{ field.placeholder || '' }}"
                        [id]="field.name"
                        class="w-full"
                        (onBlur)="onFieldBlurEvent(field.name)"
                        (ngModelChange)="onFieldChange(field.name, $event)"
                        inputStyleClass="w-full"
                        [iconDisplay]="'input'"
                        [name]="field.name"
                        [timeOnly]="true"
                        inputId="templatedisplay"
                    >
                        <ng-template #inputicon let-clickCallBack="clickCallBack">
                            <i class="pi pi-clock" (click)="clickCallBack($event)"></i>
                        </ng-template>
                    </p-datepicker>
                    <label [for]="field.name"
                        >{{ field.label }}
                        @if (field.required) {
                            <span class="text-red-500">*</span>
                        }
                    </label>
                </p-floatLabel>
            }

            <!-- p-calendar para fechas -->
            @if (field.type === 'date') {
                <p-floatLabel class="w-full">
                    <p-datepicker
                        [(ngModel)]="formData[field.name]"
                        placeholder="{{ field.placeholder || '' }}"
                        (onBlur)="onFieldBlurEvent(field.name)"
                        (ngModelChange)="onFieldChange(field.name, $event)"
                        [name]="field.name"
                        [disabled]="field.isReadOnly"
                        inputId="{{ field.name }}"
                        showIcon
                        iconDisplay="input"
                        class="w-full"
                        inputStyleClass="w-full"
                        [minDate]="field.minDate"
                        [maxDate]="field.maxDate"
                        [disabledDates]="field.disabledDates"
                        dateFormat="dd/mm/yy"
                    ></p-datepicker>
                    <label class="block text-gray-600 text-sm leading-tight break-words whitespace-normal" [for]="field.name"
                        >{{ field.label }}
                        @if (field.required) {
                            <span class="text-red-500">*</span>
                        }
                    </label>
                </p-floatLabel>
            }

            <!-- Checkbox estilo PrimeNG -->
            @if (field.type === 'checkbox') {
                <div class="mt-2">
                    <p-checkbox [binary]="true" [(ngModel)]="formData[field.name]" [name]="field.name" [inputId]="field.name" [disabled]="field.isReadOnly" (ngModelChange)="onFieldChange(field.name, $event)"></p-checkbox>
                    <label [for]="field.name" class="ml-2 text-sm text-gray-800 dark:text-gray-200">{{ field.label }}</label>
                </div>
            }

            <!-- Dropdowns -->
            @if (field.type === 'dropdown' && !field.asyncOptionsFn) {
                <p-floatLabel class="w-full">
                    <p-select
                        [options]="field.options"
                        inputId="{{ field.name }}"
                        [(ngModel)]="formData[field.name]"
                        optionLabel="label"
                        optionValue="value"
                        placeholder="{{ field.placeholder || '' }}"
                        class="w-full"
                        inputStyleClass="w-full"
                        [showClear]="true"
                        (ngModelChange)="onFieldChange(field.name, $event)"
                    />
                    <label class="block text-gray-600 text-sm leading-tight break-words whitespace-normal" [for]="field.name"
                        >{{ field.label }}
                        @if (field.required) {
                            <span class="text-red-500">*</span>
                        }
                    </label>
                </p-floatLabel>
            }

            <!-- Autocomplete con búsqueda async -->
            @if (field.type === 'dropdown' && field.asyncOptionsFn) {
                <p-floatLabel class="w-full">
                    <p-autoComplete
                        [(ngModel)]="formData[field.name]"
                        [suggestions]="asyncOptions[field.name] || []"
                        (completeMethod)="searchOptions(field.name, field.asyncOptionsFn, $event.query)"
                        (onSelect)="onFieldSelect(field.name, $event)"
                        [optionLabel]="field.optionLabel || 'nombreCompleto'"
                        [placeholder]="field.placeholder || ''"
                        [forceSelection]="true"
                        inputId="{{ field.name }}"
                        [name]="field.name"
                        class="w-full"
                        inputStyleClass="w-full"
                        [disabled]="field.isReadOnly || false"
                        [minLength]="1"
                        [delay]="250"
                    />
                    <label class="block w-full text-gray-600 text-sm leading-tight break-words whitespace-normal text-left" [for]="field.name">
                        {{ field.label }}
                        @if (field.required) {
                            <span class="text-red-500">*</span>
                        }
                    </label>
                </p-floatLabel>
            }
        </div>
    }
</ng-template>
